// extracted by mini-css-extract-plugin
export default {"contentWithoutBets":"awjef","contentWithMainBets":"OLCP0","expansionText":"qHmOW","expansion":"A3_8g","rightCellHeadToHead":"Cvzqe"};